import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import { classHelper } from "../../utils/stringUtils";
import { CaretDown } from "../svg/Icons";
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import "./FilterBox.scss";

const FilterBox = ({ className, children, eventKey = "0", ...props }) => {
	const [open, setOpen] = useState(true);
	const decoratedOnClick = useAccordionButton(eventKey, () => {
		setOpen(!open);
	});

	return props.collapsible ? (
		<Accordion
			defaultActiveKey={`${props.opendefault ? eventKey : ""}`}
			className={classHelper("filter-box", props.accordionClassName || "")}
			{...props}
		>
			<Accordion.Item eventKey={`${eventKey}`}>
				<Accordion.Button
					as="div"
					eventKey={`${eventKey}`}
					className={classHelper("fb-header cursorPointer", props.headerClassName || "")}
					onClick={decoratedOnClick}
				>
					<>
						{props.header}
						<div className={`arrow ${open ? "open" : ""}`}>
							<CaretDown stroke="#193560" className="ms-auto" />
						</div>
					</>
				</Accordion.Button>
				<Accordion.Collapse
					eventKey={`${eventKey}`}
					className={`fb-content ${props.contentClassName || ""}`}
				>
					<>{children}</>
				</Accordion.Collapse>
			</Accordion.Item>
		</Accordion>
	) : (
		<div className={classHelper("filter-box", className || "")} {...props}>
			{children}
		</div>
	);
};

export default FilterBox;
